<template>
    <div id="services" class="tabs-wrapper section-space--pt_40 section-space--pb_40" :class="BgGradient" style="background-color: rgb(234,234,234)">
        <div class="container">
          <div class="section-title-wrapper text-left section-space--mb_30">
            <h2 class="section-title font-width-light wow move-up">Services</h2>
          </div>
            <div class="row">
                <div class="col-lg-3">
                    <slick class="slick1 tab-slider-nav"
                        :options="slickOptions">
                            <div class="tab-slider-nav--list wow move-up">
<!--                                <i class="ht-slider-tab-icon fal fa-align-left"></i>-->
                              <h6 id="#ongle-incarnes">Ongles incarnés</h6>
                            </div>
                            <div class="tab-slider-nav--list wow move-up">
<!--                                <i class="ht-slider-tab-icon fal fa-rocket"></i>-->
                              <h6 id="#orthese-plantaires">Orthèses Plantaires</h6>
                            </div>
                            <div class="tab-slider-nav--list wow move-up">
                              <h6>Pieds diabétiques</h6>
                            </div>
                            <div class="tab-slider-nav--list wow move-up">
                              <h6>Douleur</h6>
                            </div>
                            <div class="tab-slider-nav--list wow move-up">
                              <h6>Soin de la peau</h6>
                            </div>
                            <div class="tab-slider-nav--list wow move-up">
                              <h6>Soin des ongles</h6>
                            </div>
                            <div class="tab-slider-nav--list wow move-up">
                              <h6>Podopédiatrie (enfants)</h6>
                            </div>
                    </slick>
                </div>
                <div id="service-details" class="col-lg-9">
                    <slick class="slick2"
                        :options="slickOptions2">
                            <!-- Ongles Incarnes -->
                            <div class="pro-large-img img-zoom wow move-up">
                              <OnglesIncarnes/>
                            </div>
                            <!-- Ortheses Plantaires -->
                            <div class="pro-large-img img-zoom wow move-up">
                              <OrthesesPlantaires/>
                            </div>
                            <!-- Pieds Diabetiques -->
                            <div class="pro-large-img img-zoom wow move-up">
                              <PiedDiabetique/>
                            </div>
                            <!-- Douleurs -->
                            <div class="pro-large-img img-zoom wow move-up">
                              <DouleurContainer/>
                            </div>
                            <!-- Soin de la peau -->
                            <div class="pro-large-img img-zoom wow move-up">
                              <PeauContainer/>
                            </div>
                            <!-- Soin des ongles -->
                            <div class="pro-large-img img-zoom wow move-up">
                              <OnglesContainer/>
                            </div>
                            <!-- Podopediatrie -->
                            <div class="pro-large-img img-zoom wow move-up">
                              <Podopediatrie/>
                            </div>
                    </slick>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Slick from 'vue-slick';
import DouleurContainer from "@/components/pied-pro-custom/soins/DouleurContainer";
import PeauContainer from "@/components/pied-pro-custom/soins/PeauContainer";
import OnglesContainer from "@/components/pied-pro-custom/soins/OnglesContainer";
import OnglesIncarnes from "@/components/pied-pro-custom/soins/OnglesIncarnes";
import PiedDiabetique from "@/components/pied-pro-custom/soins/PiedDiabetique";
import OrthesesPlantaires from "@/components/pied-pro-custom/soins/OrthesesPlantaires";
import Podopediatrie from "@/components/pied-pro-custom/soins/Podopediatrie";



    export default {
        name: 'TabTwo',
        props: ["BgGradient"],
        components: {
          Slick,
          DouleurContainer,
          OnglesIncarnes,
          PeauContainer,
          PiedDiabetique,
          OnglesContainer,
          OrthesesPlantaires,
          Podopediatrie
        },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 7,
                    focusOnSelect: true,
                    vertical: true,
                    asNavFor: '.slick2'
                },
                slickOptions2: {
                    arrows: false,
                    fade:true,
                    dots:true,
                    asNavFor: '.slick1'
                },
              items: [
                {
                  icon:'ongle-incarne1.jpg',
                  heading:'Simple order submit',
                  text:'L’ongle incarné est un problème courant qui peut devenir très douloureux et parfois même\n' +
                      'incapacitant. Il se caractérise par un ongle qui pénètre dans la peau qui l’entoure\n' +
                      'provoquant ainsi une inflammation, une rougeur et une enflure. Il peut éventuellement\n' +
                      'causer une infection avec l’apparition d’un écoulement purulent. Touchant plus souvent\n' +
                      'l’ongle du gros orteil, il peut être causé par une mauvaise coupe d’ongle ou par le port\n' +
                      'de chaussures trop étroites. Il doit être pris en charge rapidement pour éviter toute\n' +
                      'complication.'
                }
              ]
            };
        },
      methods: {
        scrollIntoView() {
          const el = this.$el.querySelector("#service-details");
          if (el) {
            el.scrollIntoView();
          }
        },
        isMobile() {
          if( screen.width <= 1060 ) {
            return true;
          }
          else {
            return false;
          }
        }
      },
      computed: {

      }
    };
</script>